import format from "date-fns/format"
import * as p from "./parse"
import en from "date-fns/locale/en-GB"
import de from "date-fns/locale/de"

const getLocale = () => (window.locale === "de" ? de : en)

export const dateLong = (date) => {
  date = typeof date === "string" ? p.parseDateLong(date) : date
  return format(date, "d MMM yyyy", {
    locale: getLocale(),
  })
}

export const dateShort = (date) => {
  date = typeof date === "string" ? p.parseDateShort(date) : date
  return format(date, "d/M/yy", {
    locale: getLocale(),
  })
}

export const dateISO = (date) => {
  date = typeof date === "string" ? p.parseDateISO(date) : date
  return format(date, "yyyy-MM-d", {
    locale: getLocale(),
  })
}

export const dateUrl = (date) => {
  date = typeof date === "string" ? p.parseDateUrl(date) : date
  return format(date, "yyyyMMd", {
    locale: getLocale(),
  })
}
